<template>
  <div>
    <div class="card p-fluid p-mt-2">
      <DataTable
        :value="permissionLevel_table"
        scrollHeight="500px"
        :paginator="true"
        :rows="10"
        dataKey="id"
        :rowHover="true"
        :loading="loading"
        :selection.sync="selectedPermission"
        :filters="filters"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #header>
          <div class="p-formgrid p-grid">
            <div class="p-field p-col-12 p-lg-1" style="padding: 7px;  " id="Create" v-if="checkAdd_data != 'false'">
              <Button
                @click="permissionModal = true"
                :label="$t('addBtn')"
                class="p-button-success"
                
              />
            </div>
            <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
              <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span>
            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>
        <Column
          field="permission_name"
          :header="$t('permission_nameLevel')"
          :sortable="true"
          :headerStyle="tableColSticky('15rem','','sticky','top')"
        >
          <template #body="dataTable">
            <div hidden>{{ dataTable.data.permission_id }}</div>
            {{ dataTable.data.permission_name }}
          </template>
        </Column>
        <Column
          field="permission_code"
          :header="$t('permission_codeLevel')"
          :sortable="true"
          :headerStyle="tableColSticky('15rem','center','sticky','top')"
        >
          <template #body="dataTable">
            <div class="table_row">
              {{ dataTable.data.permission_code }}
            </div>
            
          </template>
        </Column>
        <Column
          field="system_name"
          :header="$t('permission_level')"
          :sortable="true"
          :headerStyle="tableColSticky('15rem','','sticky','top')"
        >
          <template #body="dataTable">
            {{ dataTable.data.system_name }}
          </template>
        </Column>
        <Column :header="$t('controlTable')" 
        :headerStyle="table_headerStyle"    
        :bodyStyle="table_bodyStyle"  
        v-if="checkEdit_data != 'false' || checkDelete_data != 'false' ">
          <template #body="dataTable">
            <div class="p-formgrid col_manege">
              <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                <Button
                  @click="
                    permissionModal = true;
                    editData(dataTable.data.permission_id);
                    temp = dataTable.data.permission_id;
                  "
                  icon="pi pi-pencil"
                  :label="table_editBTN"
                  class="p-button-rounded p-button-warning"
                />
              </div>
              <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                <Button
                  @click="
                    // displayConfirmation = true;
                    temp = dataTable.data.permission_id;
                    alertDisplay(temp);
                  "
                  icon="pi pi-trash"
                  :label="table_deleteBTN"
                  class="p-button-rounded p-button-danger"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Manage permission level modal -->
    <Dialog
      :modal="true"
      :visible.sync="permissionModal"
      :style="{ width: '700px' }"
      :header="header"
    >
      <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
        <label>{{ $t("permission_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          <div class="p-formgrid p-grid">
            <div class="p-field p-col-12 p-lg-6 p-mt-2">
              <label for="permissionOptions"
                >{{ $t("permission_level") }}
                <span class="required-input">*</span></label
              >
              <Dropdown
                v-model="permission_level_select"
                :options="permissionOptions"
                optionLabel="system_name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
                :class="{ 'p-invalid': error_permission_level == true }"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="permissionOptions">
                  <div v-if="permissionOptions.value">
                    <div>{{ permissionOptions.value.system_name }}</div>
                  </div>
                  <span v-else>
                    {{ permissionOptions.placeholder }}
                  </span>
                </template>
                <template #option="permissionOptions">
                  <div>{{ permissionOptions.option.system_name }}</div>
                </template>
              </Dropdown>
              <small class="p-invalid" v-if="error_permission_level == true">{{
                $t("permission_level_validate")
              }}</small>
            </div>
            <div class="p-field p-col-12 p-lg-6 p-mt-2">
              <label for="permission_codeLevel"
                >{{ $t("permission_codeLevel") }}
                <span class="required-input">*</span></label
              >
              <InputText
                id="permission_codeLevel"
                type="text"
                v-model="permission_codeLevel"
                required="true"
                autofocus
                :class="`
                    ${error_permission_codeLevel && !permission_codeLevel ?'p-invalid ':''}
                    ${error_duplicate_codeLevel && permission_codeLevel ?'p-invalid ':''}
                    `"
                ref="TextBox_1"
                @keyup.left="moveFocus($event, 'TextBox_4','Button')"
                @keyup.right="moveFocus($event, 'TextBox_2','Input')"
                @keyup.down="moveFocus($event, 'TextBox_2','Input')"
              />
              <small
                class="p-invalid"
                v-if="error_permission_codeLevel && !permission_codeLevel"
                >{{ $t("permission_codeLevel_validate") }}</small
              >
              <small
                class="p-invalid"
                v-if="error_duplicate_codeLevel && permission_codeLevel"
                >รหัสระดับสิทธิ์ซ้ำกัน</small
              >
            </div>
          </div>
          <div class="p-formgrid p-grid p-mt-3">
            <div class="p-field p-col">
              <label for="permission_nameLevel"
                >{{ $t("permission_nameLevel") }}
                <span class="required-input">*</span></label
              >
              <InputText
                id="permission_nameLevel"
                type="text"
                v-model="permission_nameLevel"
                required="true"
                :class="{
                  'p-invalid':
                    error_permission_nameLevel && !permission_nameLevel,
                }"
                ref="TextBox_2"
                @keyup.left="moveFocus($event, 'TextBox_1','Input')"
                @keyup.right="moveFocus($event, 'TextBox_3','Button')"
                @keyup.up="moveFocus($event, 'TextBox_1','Input')"
                @keyup.down="moveFocus($event, 'TextBox_3','Button')"
              />
              <small
                class="p-invalid"
                v-if="error_permission_nameLevel && !permission_nameLevel"
                >{{ $t("permission_nameLevel_validate") }}</small
              >
            </div>
          </div>
          <!-- <div class="p-field-checkbox p-mt-3">
            <Checkbox
              id="permission_checkNotification"
              name="permission_checkNotification"
              value="1"
              v-model="permission_checkNotification"
            />
            <label for="permission_checkNotification">{{
              $t("permission_checkNotification")
            }}</label>
          </div> -->
        </div>
      </div>
      <template #footer>
        <Button
          v-if="selectedData != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
          ref="TextBox_3"
          @keyup.left="moveFocus($event, 'TextBox_2','Input')"
          @keyup.right="moveFocus($event, 'TextBox_4','Button')"
          @keyup.up="moveFocus($event, 'TextBox_2','Input')"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
          ref="TextBox_3"
          @keyup.left="moveFocus($event, 'TextBox_2','Input')"
          @keyup.right="moveFocus($event, 'TextBox_4','Button')"
          @keyup.up="moveFocus($event, 'TextBox_2','Input')"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveData()"
          ref="TextBox_4"
          @keyup.left="moveFocus($event, 'TextBox_3','Button')"
          @keyup.right="moveFocus($event, 'TextBox_1','Input')"
          @keyup.up="moveFocus($event, 'TextBox_2','Input')"
        />
      </template>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete(temp)"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Are you sure for close this modal -->
    <Dialog
      :modal="true"
      :header="$t('ConfirmCloseModal')"
      :visible.sync="displayConfirmationCloseModal"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <span>{{ $t("ConfirmCloseModalSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmationCloseModal = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="closeAllModal()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  name: "admin-permission",
  data() {
    return {
      dropdownClearFilerValue:0,
      checkRole:null,
      checkView_data:null,
      checkAdd_data:null,
      checkEdit_data:null,
      checkDelete_data:null,

      keyword: "",
      selectedPermission: null,
      permissionLevel_table: [],
      filters: {},
      temp: null,
      displayConfirmation: false,
      permissionModal: false,
      permissionOptions: [],
      permission_level_select: null,
      permission_codeLevel: "",
      permission_nameLevel: "",
      permission_checkNotification: [],
      error_permission_level: false,
      error_permission_codeLevel: false,
      error_permission_nameLevel: false,
      header: this.$i18n.t("permission_modal_title_add"),
      selectedData: "",

      check_duplicate: "",
      displayConfirmationCloseModal: false,
      tempFor_displayConfirmationCloseModal: "",
      
      loading:false,

      check_permission_codeLevel:[],
      error_duplicate_codeLevel:false,

      table_BOXmanege:window.innerWidth  > 700 ? 'p-field p-col' : '',
      table_editBTN:window.innerWidth > 700 ? this.$i18n.t('editBtn'):'',
      table_deleteBTN:window.innerWidth > 700 ? this.$i18n.t('deleteBtn'):'',

      table_headerStyle:this.checkInnerWidth('15rem','Column'),
      table_bodyStyle:this.checkInnerWidth('15rem','Body'),
    };
  },
  watch: {
    permission_level_select(val) {
      if (val != "") {
        this.error_permission_level = false;
      }
    },

    permissionModal(val) {
      if (val == false) {
        if (
          this.tempFor_displayConfirmationCloseModal == "" &&
          this.selectedData == "" &&
          this.permission_level_select != null &&
          this.permission_codeLevel != "" &&
          this.permission_nameLevel != ""
        ) {
          // this.displayConfirmationCloseModal = true;
          this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.permissionModal = false;
                      this.clearData();
                      
                    }else{
                      this.permissionModal = true;
                      this.checkCodeLevel(this.permissionLevel_table)
                    }
                  })
        } else {
          this.clearData();
          this.checkCodeLevel(this.permissionLevel_table)
        }
      }
    },

    displayConfirmationCloseModal(val) {
      if (val == true) {
        this.permissionModal = true;
      }
    },

    selectedData(val){

      if (val != "") {
        this.check_permission_codeLevel = this.check_permission_codeLevel.filter(item => item !== val.permission_code);
        // console.log("this.check_permission_codeLevel",this.check_permission_codeLevel)
      }
      
    },
    permission_codeLevel(val){
      // console.log("permission_codeLevel : ",val)
      if (this.check_permission_codeLevel.includes(val)) {
        this.error_duplicate_codeLevel = true
        // console.log("check : ",this.error_duplicate_codeLevel,this.check_permission_codeLevel.includes(val))
      }else{
        this.error_duplicate_codeLevel = false
        // console.log("check : ",this.error_duplicate_codeLevel,this.check_permission_codeLevel.includes(val))
      }
      
    },
    // check_permission_codeLevel(val){
    //   console.log("check_permission_codeLevel",val)
    // },
    // check_duplicate(val) {
    //   if (val == "duplicate") {
    //     // this.$toast.add({
    //     //   severity: "error",
    //     //   summary: "เพิ่มข้อมูลระดับสิทธิ์ไม่สำเร็จ",
    //     //   detail: "มีข้อมูลระดับสิทธิ์นี้ในระบบแล้ว",
    //     //   life: 3000,
    //     // });

    //     this.$fire({
    //           type: "error",
    //           title: "เพิ่มข้อมูลระดับสิทธิ์ไม่สำเร็จ",
    //           text: `มีข้อมูลระดับสิทธิ์นี้ในระบบแล้ว1111`,
    //           timer: 3000,
    //           confirmButtonColor: '#28B463',
    //         });
    //   } else {
    //     // this.$toast.add({
    //     //   severity: "success",
    //     //   summary: "เพิ่มข้อมูลสำเร็จ",
    //     //   detail: "ข้อมูลระดับสิทธิ์",
    //     //   life: 3000,
    //     // });
    //      this.$fire({
    //           type: "success",
    //           title: "เพิ่มข้อมูลสำเร็จ",
    //           text: `ข้อมูลระดับสิทธิ์111`,
    //           timer: 3000,
    //           confirmButtonColor: '#28B463',
    //         });
    //   }
    // },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
      this.handleResize();

    this.initialData();

    this.checkRole = JSON.parse(localStorage.getItem("data")).permission_id;

    this.checkView_data = JSON.parse(localStorage.getItem("data")).view_data;
    this.checkAdd_data = JSON.parse(localStorage.getItem("data")).add_data;
    this.checkEdit_data = JSON.parse(localStorage.getItem("data")).edit_data;
    this.checkDelete_data = JSON.parse(localStorage.getItem("data")).delete_data;

    // console.log(`checkRole = ${this.checkRole} `);
    // console.log(`checkView_data = ${this.checkView_data} `);
    // console.log(`checkAdd_data = ${this.checkAdd_data} `);
    // console.log(`checkEdit_data = ${this.checkEdit_data} `);
    // console.log(`checkDelete_data = ${this.checkDelete_data} `)
  },
  destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
  methods: {
          decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                return null;
            }
        },

        
    saveData_Modal(ModalName){
      if( ModalName === "Modal_Main"){
        if (!this.isFocused("TextBox_3") &&
            !this.isFocused("TextBox_4") ) {
            this.saveData()
        }
      }
    },
    handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : ''
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn'):''
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn'):''
            if (window.innerWidth > 700) {
              this.table_headerStyle = this.checkInnerWidth('15rem','Column')
              this.table_bodyStyle = this.checkInnerWidth('15rem','Body')
            }else{
              this.table_headerStyle = this.checkInnerWidth('105px','Column')
              this.table_bodyStyle = this.checkInnerWidth('105px','Body')
            }
    },

    async initialData() {

      this.loading = true;
      await this.axios
          .post(`${this.$url_service}/initial/option`, {
            body: { group: "dg-22" },
          })
          .then((response) => {
            this.permissionOptions = response.data.data;
          });
      await this.axios
        .post(`${this.$url_service}/admin/permission`, {
          body: {
            topic: "get-table",
          },
        })
        .then((response) => {
          this.permissionLevel_table = response.data.data;
          if (this.permissionLevel_table.length !== 0 ) {
            this.checkCodeLevel(this.permissionLevel_table)
          }
          
        });
        this.loading = false;
    },

    // check_permission_codeLevel
    checkCodeLevel(data){
      this.check_permission_codeLevel = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        this.check_permission_codeLevel.push(element.permission_code)
        
      }
    },

    closeAllModal() {
      // console.log("Close and don`t save data");
      this.permissionModal = false;
      this.displayConfirmationCloseModal = false;
      this.clearData();
    },

    async confirmDelete() {
      this.displayConfirmation = false;
      await this.axios
        .post(
          `${this.$url_service}/admin/permission?user=${this.getUsername()}`,
          {
            body: {
              topic: "delete-permission",
              id: this.temp,
            },
          }
        )
        .then(() => this.initialData());
      // console.log(`Delete ${this.temp} finish!`);
      // this.$toast.add({
      //   severity: "success",
      //   summary: "ลบข้อมูลสำเร็จ",
      //   detail: "ข้อมูลระดับสิทธิ์",
      //   life: 3000,
      // });
      this.$fire({
              type: "success",
              title: "ลบข้อมูลสำเร็จ",
              text: `ข้อมูลระดับสิทธิ์`,
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
    },

    async saveData() {
      //Check null value
        
      if (
        this.permission_level_select == null ||
        this.permission_codeLevel == "" ||
        this.permission_nameLevel == "" ||
        this.error_duplicate_codeLevel
      ) {
        if (this.permission_level_select == null) {
          this.error_permission_level = true;
        }
        if (this.permission_codeLevel == "") {
          this.error_permission_codeLevel = true;
        }
        if (this.permission_nameLevel == "") {
          this.error_permission_nameLevel = true;
        }
      } else {
        if (this.selectedData == "") {
          await this.axios
            .post(
              `${
                this.$url_service
              }/admin/permission?user=${this.getUsername()}`,
              {
                body: {
                  topic: "add-permission",
                  level_id: this.permission_level_select.system_id,
                  code: this.permission_codeLevel,
                  name: this.permission_nameLevel,
                  remind: this.permission_checkNotification,
                },
              }
            )
            .then((response) => {
              (this.check_duplicate = response.data.message),
                this.initialData();
                // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                // console.log("this.check_duplicate ",this.check_duplicate)
                if(this.check_duplicate == "duplicate" ){
                  
                  this.$fire({
                    type: "error",
                    title:"เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ",
                    text: "มีข้อมูลนี้ในระบบแล้ว",
                    timer: 3000,
                    confirmButtonColor: '#d33',
                  });
                }else{
                  this.$fire({
                        title: "เพิ่มข้อมูลสำเร็จ",
                        text: "ข้อมูลระดับสิทธิ์",
                        type: "success",
                        timer: 3000,
                        confirmButtonColor: '#28B463',
                      });
                }
                
            });
          this.tempFor_displayConfirmationCloseModal = "add";
        } else {
          await this.axios
            .post(
              `${
                this.$url_service
              }/admin/permission?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-permission",
                  id: this.temp,
                  level_id: this.permission_level_select.system_id,
                  code: this.permission_codeLevel,
                  name: this.permission_nameLevel,
                  remind: this.permission_checkNotification,
                },
              }
            )
            .then(() => this.initialData());
          // this.$toast.add({
          //   severity: "success",
          //   summary: "แก้ไขข้อมูลสำเร็จ",
          //   detail: `ข้อมูลระดับสิทธิ์`,
          //   life: 3000,
          // });
          this.$fire({
              type: "success",
              title: "แก้ไขข้อมูลสำเร็จ",
              text: `ข้อมูลระดับสิทธิ์`,
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
        }
        this.permissionModal = false;
      }
    },

    async editData(data) {
      this.header = this.$i18n.t("permission_modal_title_edit");
      await this.axios
        .post(`${this.$url_service}/admin/permission`, {
          body: {
            topic: "showone-permission",
            id: data,
          },
        })
        .then((response) => {
            (this.selectedData = response.data.data),
            (this.permission_level_select = {
              system_id: response.data.data.permission_level_id,
              system_name: response.data.data.system_name,
            }),
            (this.permission_codeLevel = response.data.data.permission_code),
            (this.permission_nameLevel = response.data.data.permission_name),
            (this.permission_checkNotification = [
              response.data.data.remind_check,
            ]);
        });
    },

    clearData() {
      this.dropdownClearFilerValue += 1;
      //Edit data
      if (this.selectedData != "") {
        this.header = this.$i18n.t("permission_modal_title_add");
        this.temp = null;
        this.displayConfirmation = false;
        this.permissionModal = false;
        this.selectedData = "";
        this.setDefault();
        //Add data
      } else {
        this.temp = null;
        this.displayConfirmation = false;
        this.setDefault();
      }
    },

    setDefault() {
      this.tempFor_displayConfirmationCloseModal = "";
      this.permission_level_select = null;
      this.permission_codeLevel = "";
      this.permission_nameLevel = "";
      this.permission_checkNotification = "";
      this.error_permission_level = false;
      this.error_permission_codeLevel = false;
      this.error_permission_nameLevel = false;
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log(temp)
                      this.confirmDelete(temp)
                    }
                  })
    },
  },
};
</script>

<style scoped>
.table_row{
  text-align: center;
}
@media screen and (min-width: 538px) and (max-width: 1200px)  {
  #Search{
      width: 21rem;
    }
}
@media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
}

@media screen and (max-width: 430px) {
 
  .EV_disasterOptions{
  width: 16.75rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table){
  border-left: 1px solid #d6d4d4;
  border-right: 1px solid #d6d4d4;
  border-collapse: separate;
  border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper){
    max-height: 550px;
    overflow: auto;
}

</style>